import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import Inputs from 'components/inputs/inputs';
import Helpers from 'utils/helpers';
import Popup from 'components/common/popup/popup';

const styles = {
  clearButton: {
    float: 'right',
    marginTop: 0,
    marginBottom: 0,
    paddingTop: 0,
    paddingBottom: 0
  }
};

export default function BackOfficeReportsTaskPageFilter(props) {
  const [isScheduled, setScheduled] = useState(props.filters && props.filters.isScheduled !== undefined ? props.filters.isScheduled : null);
  const [status, setStatus] = useState(props.filters && props.filters.status !== undefined ? props.filters.status : null);

  const handleClose = () => {
    props.onClose();
  };

  const handleSubmit = () => {
    let result = null;
    if (isScheduled != null || status != null) {
      result = {};
    }

    if (isScheduled != null) {
      result.isScheduled = isScheduled;
    }
    if (status != null) {
      result.status = status;
    }
    if (props.onChange) {
      props.onChange(result);
    }
  };

  const renderClearButton = (states, setStates, label = 'Clear') => {
    let showClear = false;
    for (var i = 0; i < states.length; i++) {
      if (states[i] !== null && (!Helpers.Object.isString(states[i]) || states[i].length > 0)) {
        showClear = true;
      }
    }

    if (!showClear) {
      return null;
    }

    const clearStates = () => {
      for (var i = 0; i < states.length; i++) {
        setStates[i](null);
      }
    };

    return <Inputs.Button variant='hover-default' onClick={clearStates} style={styles.clearButton} label={label} />;
  };

  const renderFooter = () => {
    return (
      <>
        <Inputs.Button variant='default' onClick={handleClose} iconClass='icons8-undo' label='Cancel' />
        <Inputs.Button variant='app' onClick={handleSubmit} iconClass='icons8-checkmark' label='Apply' />
      </>
    );
  };

  if (!props.show) {
    return null;
  }

  return (
    <Popup
      title='Select Filters'
      footer={renderFooter()}
      show={true}
      onClose={handleClose}
    >
      <Form>
        <Form.Group>
          <Form.Label>Status</Form.Label>
          {renderClearButton([status], [setStatus], 'Clear')}
          <Inputs.Select placeholder='Please select value' value={status ? status.toString() : ''} onValueChange={setStatus}>
            <Inputs.Option value='successful' label='Successful' />
            <Inputs.Option value='failed' label='Failed' />
          </Inputs.Select>
        </Form.Group>
        <Form.Group>
          <Form.Label>Run Type</Form.Label>
          {renderClearButton([isScheduled], [setScheduled], 'Clear')}
          <Inputs.Select placeholder='Please select value' value={isScheduled === null ? '' : isScheduled.toString()} onValueChange={(v) => setScheduled(Helpers.String.toBoolean(v))}>
            <Inputs.Option value='true' label='Scheduled' />
            <Inputs.Option value='false' label='Manual' />
          </Inputs.Select>
        </Form.Group>
        {renderClearButton([status, isScheduled], [setStatus, setScheduled], 'Clear All')}
        <div style={{ clear: 'both' }}></div>
      </Form>
    </Popup>
  );
}